
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.54 14.042l2.256-2.237L8.54 9.57l-.832.831.851.851a2.749 2.749 0 01-1.078-.178 2.636 2.636 0 01-.94-.614 2.711 2.711 0 01-.604-.91 2.62 2.62 0 01-.119-1.702c.06-.224.142-.442.248-.653l-.871-.87c-.225.329-.39.679-.495 1.048-.106.37-.158.746-.158 1.128 0 .502.099.996.297 1.485.197.488.488.923.87 1.306.383.382.812.67 1.287.86.475.192.963.294 1.464.308l-.752.752.832.83zm3.265-3.365c.225-.33.39-.68.495-1.049.106-.37.158-.745.158-1.128 0-.501-.095-1-.287-1.494a3.762 3.762 0 00-.86-1.316 3.688 3.688 0 00-1.297-.851 4.086 4.086 0 00-1.474-.277l.752-.772-.832-.832-2.256 2.237L8.46 7.431l.832-.83-.871-.872c.356 0 .719.07 1.088.208.37.139.686.34.95.604.264.264.466.567.604.91a2.623 2.623 0 01.119 1.702c-.06.225-.142.442-.248.653l.871.871zM8.5 16.417a7.71 7.71 0 01-3.088-.624A7.994 7.994 0 012.9 14.101a7.994 7.994 0 01-1.692-2.513A7.709 7.709 0 01.583 8.5c0-1.095.208-2.124.624-3.087a7.995 7.995 0 011.692-2.514 7.995 7.995 0 012.513-1.692A7.709 7.709 0 018.5.583c1.095 0 2.124.208 3.088.624.963.416 1.8.98 2.513 1.692a7.994 7.994 0 011.692 2.514 7.71 7.71 0 01.624 3.087 7.71 7.71 0 01-.624 3.088 7.994 7.994 0 01-1.692 2.513 7.994 7.994 0 01-2.514 1.692 7.71 7.71 0 01-3.087.624z"}})])
          )
        }
      }
    